/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react'

import { useLocation } from 'react-router'

import {
  Assessment,
  Close,
  Dashboard,
  FindInPage,
  Home,
  ListAlt,
  Portrait,
  Menu,
} from '@mui/icons-material'
import jwtDecode from 'jwt-decode'
import { useSelector } from 'react-redux'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'
import { IconButton } from '@mui/material'

import styles from './styles'
import NavigationItem from './NavigationItem'

const MobileNavigation = () => {
  const location = useLocation()
  const [value, setValue] = useState(location.pathname)
  const [showMenu, setShowMenu] = useState(false)
  const token = useSelector((state) => state.auth.access_token)
  const classes = styles()

  const decoded = jwtDecode(token)
  const { role } = decoded.extras

  const handleOnClick = (event) => {
    const route = event.target.getAttribute('data')
    if (route && route !== value) {
      setValue(route)
      gotoUrl(route)
    }
  }

  const handleShowMenu = () => {
    setShowMenu(!showMenu)
  }

  useEffect(() => {
    if (value !== location.pathname) setValue(location.pathname)
  }, [location.pathname])

  return (
    <div className={classes.root}>
      <IconButton onClick={handleShowMenu} className={classes.buttonMenu}>
        {!showMenu ? <Menu /> : <Close />}
      </IconButton>
      {showMenu && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <div className={classes.itemsContainer} onClick={handleShowMenu}>
          <div className={classes.itemsWrapper}>
            <NavigationItem
              label={role === 'Prospect' ? 'Home' : 'Aplicações'}
              href={
                role === 'Prospect'
                  ? ROUTE_CONSTANTS.PROSPECT_DASHBOARD
                  : ROUTE_CONSTANTS.HOME
              }
              value={value}
              Icon={role === 'Prospect' ? Home : Portrait}
              onClick={handleOnClick}
            />
            {role !== 'Prospect' ? (
              <React.Fragment>
                <NavigationItem
                  label="análises manuais"
                  href={ROUTE_CONSTANTS.MANUAL_ANALISYS_AUDIT}
                  value={value}
                  Icon={FindInPage}
                  onClick={handleOnClick}
                />
                <NavigationItem
                  label="Estatísticas"
                  href={ROUTE_CONSTANTS.STATISTICS}
                  value={value}
                  Icon={Assessment}
                  onClick={handleOnClick}
                />
                <NavigationItem
                  label="Formulários Due Diligence"
                  href={ROUTE_CONSTANTS.DUE_DILIGENCE_LIST}
                  value={value}
                  Icon={ListAlt}
                  onClick={handleOnClick}
                />
                <NavigationItem
                  label="Antifraude"
                  href={ROUTE_CONSTANTS.ANTIFRAUDE_DASHBOARD}
                  value={value}
                  Icon={Dashboard}
                  onClick={handleOnClick}
                />
              </React.Fragment>
            ) : null}
          </div>
        </div>
      )}
    </div>
  )
}

export default MobileNavigation
